import {Fragment, useEffect, useState} from "react";
import { IconButton } from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Add from "@mui/icons-material/Add";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditFarmerModal from "./editFarmerModal";
import AddFarmerModal from "./addFarmerModal";
import { API_BASE_URL } from "../baseURL";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Farmer from "./farmer";

const FarmersTable = () => {
    const [farmers, setFarmers] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [farmer, setFarmer] = useState(null);
    const [users, setUsers] = useState(null);
    const [expandedRow, setExpandedRow] = useState(null);

    useEffect(() => {
        if (!farmers) {
            fetch(`${API_BASE_URL}/farmers`, {
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem('token')
                },
                method: "GET"
            })
                .then((response) => response.json())
                .then((data) => setFarmers(data));
        }
        if (!users) {
            fetch(`${API_BASE_URL}/users/salespersons`, {
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem('token')
                },
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => setUsers(data));
        }

    }, []);


    const handleKeyPress = () => {
        farmers.forEach(farmer => farmer.isHidden = false);

        let inputVal = document.getElementById("search").value;

        const filteredData = farmers.map(farmer => {
            if(!farmer.surname.toLowerCase().includes(inputVal.toLowerCase()) &&
                !farmer.plz.includes(inputVal.toLowerCase()) &&
                !farmer.location.toLowerCase().includes(inputVal.toLowerCase())) {
                farmer.isHidden = true;
            }
            return farmer;
        })

        setFarmers(filteredData);
    };

    function cleanInput() {
        document.getElementById("search").value = "";

        const filteredData = farmers.map(farmer => {
             farmer.isHidden = false
             return farmer;
            }
        )

        setFarmers(filteredData);
    }

    function deleteFarmer(farmerId) {
        fetch(`${API_BASE_URL}/farmers/${parseInt(farmerId)}/delete`, {
            method: "DELETE",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
        }).then((response) => response.json())
            .then((data) => setFarmers(data));
    }

    const handleSelectAD = (event) => {
        let user = event.target.value;

        farmers.forEach(farmer => farmer.isHidden = false);

        if(user === "Ohne AD") {
            user = null
        }

        const filteredData = farmers.map(farmer => {
            if(farmer.user !== user) {
                farmer.isHidden = true;
            }
            return farmer;
        })

        setFarmers(filteredData);
    };

    const toggleRow = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
    };

    return (
        <>
            { farmers ? (
                <div style={{margin: "20px 20px 20px 20px"}}>
                    <IconButton style={{float: "right"}}>
                        <Add fontSize="inherit" className="custom-btn-add" onClick={() => {
                            setShowAddModal(true);
                            // setFarmer(23);
                        }} />
                    </IconButton>

                    <input
                        type="text"
                        placeholder="Nachname/PLZ/Ort..."
                        id="search"
                        className="mb-4 p-2 border border-gray-300 rounded"
                        onKeyUp={handleKeyPress}
                    />

                    <IconButton >
                        <DeleteForeverIcon style={{color: "red", fontSize: "40px"}} onClick={ cleanInput }></DeleteForeverIcon>
                    </IconButton>

                    <FormControl sx={{ width: 250, marginLeft: "70px" }}>
                        <InputLabel>AD wählen</InputLabel>
                        <Select
                            id="user"
                            onChange={ handleSelectAD }
                            variant="outlined">
                                <MenuItem value="Ohne AD">Ohne AD</MenuItem>
                                { users ?
                                    users.map((user) => {
                                        return (
                                            <MenuItem key={user.id} value={user.surname}>{user.surname}</MenuItem>
                                        );
                                    }): null }
                        </Select>
                    </FormControl>

                    <table>
                        <thead>
                            <tr>
                                <th style={{ paddingLeft: "20px"}}> Nr. </th>
                                <th> Nachname </th>
                                <th> Vorname </th>
                                <th> E-mail </th>
                                <th> Adresse </th>
                                <th> PLZ </th>
                                <th> Ort </th>
                                <th> Festnetz </th>
                                <th> Handynummer </th>
                                <th> Land </th>
                                <th> AD </th>
                                <th> Kommentar </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                farmers.map((farmer, index) => farmer.isHidden ? null : (
                                    <>
                                        <tr>
                                            <td style={{ paddingLeft: "20px"}}>{index + 1}.</td>
                                            <td
                                                onClick={()=> toggleRow(farmer.id) }
                                                style={{ cursor: "pointer", color: "blue" }}>
                                                { expandedRow === farmer.id ? "▼" : "▶" } { farmer.surname }
                                            </td>
                                            <td>{farmer.firstName}</td>
                                            <td >{farmer.email}</td>
                                            <td>{farmer.address}</td>
                                            <td>{farmer.plz}</td>
                                            <td>{farmer.location}</td>
                                            <td>{farmer.festnetz}</td>
                                            <td>{farmer.handy}</td>
                                            <td>{farmer.land}</td>
                                            <td>{farmer.user}</td>
                                            <td>{farmer.comment}</td>

                                            <td className="actions">
                                                <IconButton>
                                                    <Edit className="custom-btn-edit"
                                                          onClick={() => {
                                                              setShowEditModal(true);
                                                              setFarmer(farmer);
                                                          }} />
                                                </IconButton>
                                                <IconButton>
                                                    <DeleteIcon className="custom-btn-delete" data-confirm="Are you sure to delete this item?"
                                                                onClick={() => {  if(window.confirm("Wirklich entfernen?")) {
                                                        deleteFarmer(farmer.id);
                                                    }}} />
                                                </IconButton>
                                            </td>
                                        </tr>

                                        { expandedRow === farmer.id && (
                                            <tr>
                                                <td colSpan={13}>
                                                    <Farmer farmer={farmer} setFarmer={setFarmer} />
                                                </td>
                                            </tr>
                                        ) }
                                    </>
                                ))
                            }

                            { showEditModal ? (
                                <EditFarmerModal farmer={farmer} setFarmers={setFarmers} setShowEditModal={setShowEditModal} />
                            ) : null }

                            { showAddModal ? (
                                <AddFarmerModal setFarmers={setFarmers} setShowAddModal={setShowAddModal} />
                            ) : null }
                        </tbody>
                    </table>
                </div>
            ): null }
        </>
    )
}

export default FarmersTable;
